export default __webpack_public_path__ + "static/gtao_bunker-cca68e9485c2612d4c25d43d9460ffa1.jpg";